import React, {
  useCallback,
  useState,
} from "react";

import AlertBox from "./MyAlertBox";

const useAlert = ({
  mode = "snackbar",
} = {}) => {
  const [
    alertProps,
    setAlertProps,
  ] = useState(null);

  const showAlert =
    useCallback(
      (
        status,
        type,
        message,
        control,
        onConfirm,
      ) => {
        return new Promise(
          (resolve) => {
            setAlertProps({
              status,
              type,
              message,
              control,
              onConfirm,
              resolve,
            });
          },
        );
      },
      [],
    );

  const handleClose =
    useCallback(() => {
      if (!alertProps) {
        return;
      }

      alertProps.resolve?.(
        false,
      );

      setAlertProps(null);
    }, [alertProps]);

  const handleConfirm =
    useCallback(() => {
      if (!alertProps) {
        return;
      }

      alertProps.onConfirm?.();

      alertProps.resolve?.(
        true,
      );

      setAlertProps(null);
    }, [alertProps]);

  const AlertComponent =
    alertProps ? (
      <AlertBox
        status={
          alertProps.status
        }
        type={
          alertProps.type
        }
        message={
          alertProps.message
        }
        control={
          alertProps.control
        }
        mode={mode}
        onClose={
          handleClose
        }
        onConfirm={
          handleConfirm
        }
      />
    ) : null;

  return {
    showAlert,
    AlertComponent,
  };
};

export default useAlert;